import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../../../src/app/shared/services/data.service';
import { LoaderService } from '../../../../../src/app/shared/services/loader/loader.service';
import { ResponseData } from '../../../../../src/app/shared/services/teacher.interface';

@Component({
  selector: 'app-quiz-completed',
  templateUrl: './quiz-completed.component.html',
  styleUrls: ['./quiz-completed.component.scss']
})
export class QuizCompletedComponent implements OnInit{

  userGroupId = sessionStorage.getItem('GCTeamId');
  groupId  = this.userGroupId ? this.userGroupId : ''
  canShowTeams = false;
  win_teams : string[] = []

  constructor(private dataService:DataService,
    private loader:LoaderService
  ) { }

  ngOnInit(): void {
    history.pushState(null, "", window.location.href);
    // this.loader.display(true);
    this.dataService.getFinalResult(this.groupId).subscribe({
      next:(res:ResponseData<{winning_team:string[]}>) =>{
        this.win_teams = (res.data?.winning_team?.length != 0) ? res?.data?.winning_team : [];
        this.canShowTeams = true;
      },
      error:(err:HttpErrorResponse) =>{
        console.error(err);
        this.canShowTeams = true;
      },
    })
  }

  getTeams(win_teams: string[]): string {    
    const modifiedTeams = win_teams.slice().map((item)=>item.replace('Team ',''))
    const lastTeam = modifiedTeams.pop();
    return modifiedTeams.join(', ') + ` & ${lastTeam}`;
  }
}
